import MainNav from './MainNav';

export default MainNav;



// WEBPACK FOOTER //
// ./src/components/shared/MainNav/index.js